<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="download-save-upload"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g id="Group_1068" data-name="Group 1068" transform="translate(2.25 2.25)">
      <path
        id="Path_8485"
        data-name="Path 8485"
        d="M9.75,13.5V3M16.5,13.5a3,3,0,0,1-3,3H6a3,3,0,0,1-3-3"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#768391'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8486"
        data-name="Path 8486"
        d="M14.5,12l-3.751,3.751L7,12"
        transform="translate(-4 -5.25)"
        fill="none"
        :stroke="clr ? clr : '#768391'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8487" data-name="Path 8487" d="M0,0H18V18H0Z" fill="none" />
  </svg>
</template>
<style scoped>
path {
  transition: all 0.5s ease-out 0.5s;
}
</style>
